import { memo, useMemo } from 'react';
import { ColorByOption } from './ClinicMapView';
import { COLOR_BY_OPTIONS, LEGEND_LABELS } from './constants';

interface MapLegendProps {
  colorBy: ColorByOption;
  viewMode: 'markers' | 'heatmap';
  colorSchemes: Record<ColorByOption, Record<string, string>>;
}

const MapLegend = ({ colorBy, viewMode, colorSchemes }: MapLegendProps) => {
  const legendItems = useMemo(() => {
    const scheme = colorSchemes[colorBy];
    const labels = LEGEND_LABELS[colorBy];
    return Object.entries(scheme)
      .filter(([key]) => key !== 'unknown')
      .map(([key, color]) => ({
        color,
        label: labels[key] || key,
      }));
  }, [colorBy, colorSchemes]);

  return (
    <div className="absolute bottom-6 left-4 z-[1000] rounded-lg border border-gray-200 bg-white p-3 shadow-md">
      {viewMode === 'markers' ? (
        <>
          <div className="mb-2 text-xs font-medium text-gray-500">
            {COLOR_BY_OPTIONS.find(o => o.value === colorBy)?.label}
          </div>
          <div className="space-y-1">
            {legendItems.map(item => (
              <div key={item.label} className="flex items-center gap-2">
                <span className="h-3 w-3 rounded-full" style={{ backgroundColor: item.color }} />
                <span className="text-xs text-gray-700">{item.label}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="mb-2 text-xs font-medium text-gray-500">Clinic Density</div>
          <div className="flex items-center gap-2">
            <div
              className="h-3 w-28 rounded"
              style={{
                background:
                  'linear-gradient(to right, #3B82F6, #06B6D4, #10B981, #F59E0B, #F97316, #EF4444)',
              }}
            />
          </div>
          <div className="mt-1 flex justify-between text-xs text-gray-500">
            <span>Low</span>
            <span>High</span>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(MapLegend);
